import React from "react";
import Hooks from "@hooks";
import { Filter } from "./filter";
import { Form } from "@components";

type Props = {
  current: {
    search: string;
    host: string[];
    type: string[];
  };
  onChange: (name: "host" | "type", value: string, checked: boolean) => void;
};

export const Filters: React.FC<Props> = ({ current, onChange }) => {
  const applications = Hooks.useApplications();
  const filters = React.useMemo(() => {
    return applications.value
      ? {
          host: applications.value.reduce<string[]>(
            (options, application) =>
              options.includes(application.host)
                ? options
                : options.concat(application.host),
            []
          ),
          type: applications.value.reduce<string[]>(
            (options, application) =>
              options.includes(application.type)
                ? options
                : options.concat(application.type),
            []
          ),
        }
      : null;
  }, [applications]);

  return filters ? (
    <Form>
      <Form.Group
        label={{
          text: "Filter by Domain / Host",
          tooltip: "Tooltip content",
        }}
        spacing={0}
      >
        {filters.host.map((option) => (
          <Filter
            key={option}
            checked={current.host.includes(option)}
            name="host"
            onChange={onChange}
            option={option}
          />
        ))}
      </Form.Group>
      <Form.Divider size={6} />
      <Form.Group
        label={{
          text: "Filter by classification",
          tooltip: "Tooltip content",
        }}
        spacing={0}
      >
        {filters.type.map((option) => (
          <Filter
            key={option}
            checked={current.type.includes(option)}
            name="type"
            onChange={onChange}
            option={option}
          />
        ))}
      </Form.Group>
    </Form>
  ) : null;
};
